import { render, staticRenderFns } from "./mobile_privacy_policy.vue?vue&type=template&id=5a3043de&scoped=true&"
import script from "./mobile_privacy_policy.vue?vue&type=script&lang=js&"
export * from "./mobile_privacy_policy.vue?vue&type=script&lang=js&"
import style0 from "./mobile_privacy_policy.vue?vue&type=style&index=0&id=5a3043de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3043de",
  null
  
)

export default component.exports